import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';

import { Network } from 'react-fns';
import { Router } from 'react-router';
import { LastLocationProvider } from 'react-router-last-location';
import { injectIntl } from 'react-intl';

import BasePage from './components/BasePage/BasePage';
import BaseHeader from './components/BasePage/Header';
import BaseContent from './components/BasePage/LargeContent';
import Header from './components/Header/Header';
import LandscapeWarning from './components/LandscapeWarning/LandscapeWarning';
import OfflineWarning from './components/OfflineWarning/OfflineWarning';
import AppRoute from './AppRoute';
import messages from './messages';

@inject('authStore', 'uiState', 'fileUploadStore')
@observer
class App extends Component {
  componentDidMount() {
    window.addEventListener('beforeunload', this.handleLeavePage);
  }

  componentWillUnmount() {
    window.removeEventListener('beforeunload', this.handleLeavePage);
  }

  handleLeavePage = e => {
    const { fileUploadStore } = this.props;
    if (!fileUploadStore.canDrop) {
      const confirmationMessage =
        'Er zijn nog files bezig aan het opladen. Deze files gaan verloren indien je de pagina afsluit.';
      e.returnValue = confirmationMessage; // Gecko, Trident, Chrome 34+

      return confirmationMessage; // Gecko, WebKit, Chrome <34
    }
  };
  render() {
    const { authStore: { isLoggedIn }, uiState, history, intl } = this.props;
    return (
      <Router history={history}>
        <LastLocationProvider>
          <BasePage fullheight>
            <BaseHeader isLoggedIn={isLoggedIn}>
              <Header menuClick={() => uiState.toggleMenu()} />
            </BaseHeader>
            <BaseContent>
              <AppRoute />
            </BaseContent>
            <LandscapeWarning
              title={intl.formatMessage(messages.landscapeWarningTitle)}
              message={intl.formatMessage(messages.landscapeWarningDescription)}
            />
            <Network
              render={({ online, offlineAt }) => (
                <div>
                  {online ? null : (
                    <OfflineWarning
                      title={intl.formatMessage(messages.offlineWarningTitle)}
                      message={intl.formatMessage(
                        messages.offlineWarningDescription
                      )}
                    />
                  )}
                </div>
              )}
            />
          </BasePage>
        </LastLocationProvider>
      </Router>
    );
  }
}

export default injectIntl(App);



// WEBPACK FOOTER //
// ./src/App.js